import { render } from "./NotionBlockRenderer.vue?vue&type=template&id=71602348"
import script from "./NotionBlockRenderer.vue?vue&type=script&lang=js"
export * from "./NotionBlockRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__